import { render } from "./QuizGuessAnswers.vue?vue&type=template&id=339cf5b6"
import script from "./QuizGuessAnswers.vue?vue&type=script&lang=js"
export * from "./QuizGuessAnswers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__